export const FETCH_CAMPAIGN = "FETCH_CAMPAIGN_TAG";
export const FETCH_JOBS = "FETCH_JOBS_TAG";
export const FETCH_REC_DETAILS = "FETCH_REC_DETAILS_TAG";
export const USER_PROFILES = "USER_PROFILES_API"
export const FETCH_COMMUNICATIONS = "FETCH_COMMUNICATIONS_API"
export const FETCH_FOLDERS = "FETCH_FOLDERS_API"
export const FETCH_ALERTS = "FETCH_ALERTS_API"
export const FETCH_INVENTORY = "FETCH_INVENTORY_API"
export const FETCH_DOWNLOADS = "FETCH_DOWNLOADS_API"
